import * as React from "react";
import {OnFailure, OnSuccess} from "../../../../store/action/actionHelpers";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import Toast from "../../../helper/Toast";
import JobStatus from "../../../../model/job/JobStatus";
import EditJobStatusFormView from "./EditJobStatusFormView";
import {editJobStatus} from "../../../../store/action/jobStatus/jobStatus";

interface IComponentProps {
	/**
	 * On successful edited job status callback.
	 */
	onSuccess: () => void;
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
	/**
	 * Job status to edit
	 */
	editedJobStatus: JobStatus;
}

interface IDispatchProps {
	/**
	 * Update job status.
	 * @param {JobStatus} data
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	updateJobStatus: (data: JobStatus, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

interface IState {
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
}

type Props = IComponentProps & IDispatchProps

class EditJobStatusForm extends React.PureComponent<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {isSubmitting: false};
		this.onSubmit = this.onSubmit.bind(this);
	}

	render() {
		return (
			<EditJobStatusFormView onSubmit={this.onSubmit}
								   onCancel={this.props.onCancel}
								   isSubmitting={this.state.isSubmitting}
								   editedJobStatus={this.props.editedJobStatus}/>
		);
	}

	onSubmit(data: JobStatus) {
		this.setState({isSubmitting: true}, () => {
			this.props.updateJobStatus(
				data,
				() => {
					this.setState({isSubmitting: false}, () => {
						Toast.success("Job status updated", "Job status update");
						this.props.onSuccess();
					});
				},
				(error) => {
					let err = "Sorry, something went wrong. Try again later.";
					if (error && error.response && error.response.status === 409
						&& error.response.data.exception == "DuplicateJobStatusLabelException") {
						err = "Job status with given name already exists";
					}
					this.setState({isSubmitting: false},
						() => Toast.error(err, "Job status update"));
				}
			);
		});
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>, props: IComponentProps) {
	return {
		updateJobStatus: (data: JobStatus, onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(editJobStatus(props.editedJobStatus.id, data, onSuccess, onFailure))
	};
}

export default connect(null, mapDispatchToProps)(EditJobStatusForm);
